module.exports = require("./mai.d.ts");